import frequency from '#components/calendar/js/mains/event/addEdit/repeat/frequency/frequency.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const handlers = new WeakMap()
const wrappers = new WeakMap()
const items = new WeakMap()

const onClick = object(listener, {
  type: click,
  task: async radio => {
    const wrapper = wrappers.get(radio)
    const item = items.get(radio)

    await handlers.get(radio)?.(radio, wrapper, item)
  }
})

export const handle = (element, handler) => {
  const wrapper = closest(`[data-contract*="event.addEdit.repeat.end.wrapper"]`, element)
  const item = closest(`.ea_calendar__event_repeat_group`, element)

  if (!wrappers.has(wrapper)) {
    return
  }

  wrappers.set(element, wrapper)
  handlers.set(element, handler)
  items.set(element, item)
  onClick.listen(element)

  queueMicrotask(async () => {
    await removed(element)
    handlers.delete(element)
    wrappers.delete(element)
    items.delete(element)
  })
}

export default wrapper => {
  wrappers.set(wrapper, wrapper)

  queueMicrotask(async () => {
    await removed(wrapper)
    wrappers.delete(wrapper)
  })
}